import { useIsDarkMode } from '@marketplace-web/dark-mode/dark-mode-feature'
import { useFeatureSwitch } from '@marketplace-web/feature-flags/feature-switches-data'
import { CountryCode } from '@marketplace-web/domain/country-data'

import { SecondhandTaxesPageModel } from '../types'
import { dac7LayoutMapper, fallbackLayout } from '../components/content/content'

const getCurrentLayout = (countryCode: CountryCode, isDarkMode: boolean) => {
  const selectedLayout = dac7LayoutMapper.find(({ countries }) => countries.includes(countryCode))

  return selectedLayout
    ? selectedLayout.layout(countryCode.toUpperCase(), isDarkMode)
    : fallbackLayout()
}

const useSecondhandTaxesPageContent = (countryCode: CountryCode): SecondhandTaxesPageModel => {
  const dynamicLayoutEnabled = useFeatureSwitch('dac7_dynamic_layout_content')
  const isDarkMode = useIsDarkMode()

  return dynamicLayoutEnabled ? getCurrentLayout(countryCode, isDarkMode) : fallbackLayout()
}

export default useSecondhandTaxesPageContent
